module.exports = __webpack_public_path__ + "img/no-results-2.b9936e62.svg";